import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@lib/utils/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  error?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, leftIcon, rightIcon, error, ...rest }, ref) => (
    <div className={cn('relative w-full', className)}>
      {leftIcon && (
        <span className="absolute inset-y-0 start-3 flex items-center text-fg-subtle pointer-events-none">
          {leftIcon}
        </span>
      )}
      <input
        ref={ref}
        className={cn(
          'flex h-9 w-full rounded-md border bg-surface px-3 text-sm',
          'placeholder:text-fg-subtle',
          'focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent',
          'disabled:cursor-not-allowed disabled:opacity-60',
          leftIcon && 'ps-10',
          rightIcon && 'pe-10',
          error ? 'border-danger focus:ring-danger' : 'border-border',
        )}
        {...rest}
      />
      {rightIcon && (
        <span className="absolute inset-y-0 end-3 flex items-center text-fg-subtle">
          {rightIcon}
        </span>
      )}
    </div>
  ),
);
Input.displayName = 'Input';
